<template>
  <div class="product min-contain">
    <div class="product-main">
      <section class="product-header">
        <h4 class="title">Healthy and delicious seafood</h4>
        <p class="intro">
          Thanks to our world-leading, innovative and sustainable approach, we
          offer a wide selection of healthy, delicious seafood. Our customers
          can choose from a range of products, including whole gutted fish,
          fillets and steaks, to ready-to-eat items like smoked salmon and
          portioned fish.
        </p>
      </section>

      <section class="goal">
        <img src="../assets/img/Rectangle-8.jpg" alt="" />
      </section>

      <div class="product-advantages">
        <el-divider>PRODUCT ADVANTAGES</el-divider>
        <div class="product-advantages-contain">
          <div class="item" v-for="(v, key) in advantagesInfo" :key="key">
            <div class="wrapper">
              <img :src="v.img" alt="" />
              <div class="contain">
                <div class="title">{{ v.title }}</div>
                <div class="intro">{{ v.intro }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Product",
  data() {
    return {
      advantagesInfo: [
        {
          //   name: "物流轨迹实时可视",
          title: "Health benefits",
          intro:
            "Not only does salmon taste great, it is a smart food choice for your health too.",
          img: require("../assets/img/product-1.png"),
        },
        {
          title: "Safe Seafood",
          intro: "Consuming farmed salmon is both safe and healthy.",
          img: require("../assets/img/product-2.jpg"),
        },
        {
          title: "Quality Seafood",
          intro:
            "Every day, we produce high-quality farm-raised salmon and value- added products.",
          img: require("../assets/img/product-3.png"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.product-advantages {
  height: 650px;
  min-height: 60vh;
  background: #fff;
  padding: 30px 10px;

  .title {
    font-size: 24px;
    text-align: center;
    color: #000;
  }
  .product-advantages-contain {
    display: flex;
    align-content: center;
    justify-content: space-evenly;
    margin-top: 10%;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      .wrapper {
        padding: 2px;
      }
      img {
        width: 100%;
        height: 227px;
        object-fit: cover;
      }
      .contain {
        margin-top: -4px;
        padding: 20px;
        background-color: #3c3b3b;
        color: white;
        .title {
          font-weight: 700;
          font-size: 26px;
          margin-bottom: 18px;
          color: white;
        }
        .intro {
          font-size: 15px;
          line-height: 26px;
          text-align: center;
        }
      }
    }
  }
}

.product-main {
  width: 1168px;
  margin: 0 auto;
}

.product-header {
  margin: 100px 0;
  width: 820px;
  margin: 150px auto 0;
  .title {
    font-size: 44px;
    color: #404041;
    font-weight: 700;
    text-align: center;
  }
  .intro {
    font-size: 15px;
    color: #404041;
    line-height: 26px;
    text-align: center;
  }
}

.goal {
  margin: 80px auto;
  position: relative;
  img {
    display: block;
    margin: 0 auto;
    width: 758px;
    height: 560px;
  }
}
</style>
